import {call, put} from 'redux-saga/effects';
import ClientActions from '../redux/ClientRedux';
import ClientsActions from '../redux/ClientsRedux';
import CarsActions from '../redux/CarsRedux';
import MessagesActions from '../redux/MessagesRedux';
import { preparePhoneNumber } from '../helpers/string';

export function * getClient(api, action) {
  const response = yield call(api.getClient, action.id);

  if (response.ok) {
    const {client, cars, ids} = transformClientData(response.data);
    yield put(ClientActions.clientSuccess(client));
    yield put(CarsActions.carsSuccess(cars, ids));
  } else {
    yield put(ClientActions.clientFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

const transformClientData = data => {
  let client = {...data};
  let ids = null;
  let cars = null;
  if (client.cars && client.cars.length) {
    ids = [];
    cars = {};
    client.cars.map(car => {
      ids.push(car.id);
      cars[car.id] = {...car};
    });
  }
  delete client.cars;
  return {client, ids, cars};
}

export function * addClient(api, action) {
  let data = {...action.data};
  data.phone = preparePhoneNumber(data.phone); // формируем корректный номер телефона

  const response = yield call(api.addClient, data);

  if (response.ok) {
    yield put(ClientActions.clientSuccess(response.data));
    yield put(ClientsActions.clientsSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'clientAdd', title: 'Запись успешно создана'}));
  } else {
    yield put(ClientActions.clientFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * updateClient(api, action) {
  let data = {...action.data};
  // формируем корректный номер телефона
  if (data.phone) {
    data.phone = preparePhoneNumber(data.phone);
  }

  const response = yield call(api.editClient, {...action.data});

  if (response.ok) {
    yield put(ClientActions.clientSuccess(response.data));
    yield put(ClientsActions.clientsSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'clientUpdate', title: 'Запись успешно обновлена'}));
  } else {
    yield put(ClientActions.clientFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}

export function * deleteClient(api, action) {
  const response = yield call(api.deleteClient, action.id);

  if (response.ok) {
    yield put(ClientActions.clientSuccess(null));
    yield put(ClientsActions.clientsSuccess(null));
    yield put(MessagesActions.messagesShow({type: 'success', code: 'clientDelete', title: 'Запись успешно удалена'}));
  } else {
    yield put(ClientActions.clientFailure(response.data && response.data.title ? response.data.title : response.problem));
    yield put(MessagesActions.messagesShow({type: 'error', code: response.status, title: response.data && response.data.title ? response.data.title : response.problem}));
  }
}
